require('./bootstrap');
require('lightbox2');
// require('lightbox2/dist/js/lightbox');
// require('lightbox2/dist/js/lightbox-plus-jquery');

// REACT COMPONENTS
require('./components/Example');
